import {ScreenComponent} from './ScreenComponent.js';
import {div} from '@megaphonenpm/mputils/src/DOM.js';

/**
 * Simple progress bar, showing "percentage complete" as a horizontal rectangle.
 */
export class ProgressBar extends ScreenComponent {
  constructor () {
    super();
  }

  build () {
    super.build();
    this.view = div(null, 'progressbar');
    this.foreground = div('foreground');
    this.view.append(this.foreground);
  }

  setValue (value) {
    this.value = value;
    this.foreground.style.width = `${Math.round((this.value/this.total)*100)}%`;
  }

  setTotal (total) {
    this.total = total;
  }

  getCSS () {
    let css = `
    .progressbar {
      position: relative;
    }
    
    .progressbar #foreground {
      position: absolute;
      width: 0%;
      height: 100%;
    }
    `

    return css;
  };
}
